import { Navigate } from "react-router-dom";

import { useCurrentUser } from "@/hooks/useCurrentUser";

interface CertifiedFounderRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that only allows certified founders (certified, pro, or x level) to access.
 * Non-certified founders are redirected to the dashboard.
 */
const CertifiedFounderRoute = ({ children }: CertifiedFounderRouteProps) => {
  const { user, isLoading } = useCurrentUser();

  // Wait for user data to load
  if (isLoading) {
    return null;
  }

  // Check if user is certified (certified, pro, or x level)
  const level = user?.level?.toLowerCase();
  const isCertified = level === "certified" || level === "pro" || level === "x";

  if (!isCertified) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default CertifiedFounderRoute;
